var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopTabCompetitorChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6948_26502)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.125 0.75H1.875C1.25475 0.75 0.75 1.25475 0.75 1.875V17.25H9V18H0V1.875C0 0.84075 0.8415 0 1.875 0H10.125C11.1593 0 12 0.84075 12 1.875V8.26725C11.7142 8.48325 11.4645 8.74125 11.25 9.027V1.875C11.25 1.25475 10.7452 0.75 10.125 0.75ZM5.25 9.75H3V10.5H5.25V9.75ZM6.75 10.5H9V9.75H6.75V10.5ZM3 13.5H5.25V12.75H3V13.5ZM6.75 13.5H9V12.75H6.75V13.5ZM5.25 3.75H3V4.5H5.25V3.75ZM6.75 4.5H9V3.75H6.75V4.5ZM5.25 6.75H3V7.5H5.25V6.75ZM6.75 7.5H9V6.75H6.75V7.5ZM16.125 14.25H12.375C11.3407 14.25 10.5 15.0907 10.5 16.125V18H11.25V16.125C11.25 15.5048 11.7548 15 12.375 15H16.125C16.7453 15 17.25 15.5048 17.25 16.125V18H18V16.125C18 15.0907 17.1593 14.25 16.125 14.25ZM12 11.25C12 10.0095 13.0095 9 14.25 9C15.4905 9 16.5 10.0095 16.5 11.25C16.5 12.4905 15.4905 13.5 14.25 13.5C13.0095 13.5 12 12.4905 12 11.25ZM12.75 11.25C12.75 12.0773 13.4227 12.75 14.25 12.75C15.0773 12.75 15.75 12.0773 15.75 11.25C15.75 10.4227 15.0773 9.75 14.25 9.75C13.4227 9.75 12.75 10.4227 12.75 11.25Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6948_26502"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopTabCompetitorChart);
export default __webpack_public_path__ + "static/media/TopTab-Competitor-Chart.fa291c4af78ddf6c80dc10b349a9d4e8.svg";
export { ForwardRef as ReactComponent };